export enum STORAGE_KEYS {
  departmentName = 'departmentName',
  organisationId = 'organisationId',
  cookieConsentName = 'cookieConsentName',
}
